var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('formatted-input',_vm._g(_vm._b({attrs:{"rules":_vm.customRules.concat( [_vm.validateNumberRule]),"formatter":_vm.formatter}},'formatted-input',Object.assign({}, _vm.$attrs, _vm.$props),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }